import { atom } from 'jotai';

import type { WorkSpaceDetailsModel } from '../../types';

export const currentWorkspaceDetailAtom = atom<WorkSpaceDetailsModel | null>(
  null
);
